<template>
    <div>
        <b-table striped small outlined responsive stacked="sm" primary-key="id" :items="items" :fields="fields">
            <template v-slot:cell(dimension)="data">
                <span v-html="data.value"></span>
            </template>
            <template v-slot:cell(name)="data">
                <b-link v-b-tooltip.hover :title="data.item.description">{{ data.item.name }}</b-link>
            </template>
        </b-table>
        <RadarChart :item="radarItems" :labels="radarLabels"/>
    </div>
</template>

<script>
    import _ from 'lodash';
    import Diagnosis from './Diagnosis';
    import RadarChart from "./charts/RadarChart";

    let rowIndex = 1;

    export default {
        components: {
            RadarChart
        },
        props: {
            item: {
                type: Object,
            },
        },
        computed: {
            items() {
                rowIndex = 1;
                let result = [];
                for (let dataKey in Diagnosis.data()) {
                    result.push(this.generateItem(dataKey));
                }
                return result;
            },
            radarItems() {
                return [
                    Diagnosis.data().sop.converter(this.item.out.sop),
                    Diagnosis.data().ipa.converter(this.item.out.ipa),
                    Diagnosis.data().ksd.converter(this.item.out.ksd),
                    Diagnosis.data().iemo.converter(this.item.out.iemo),
                    Diagnosis.data().kyad.converter(this.item.out.kyad),
                    Diagnosis.data().ia.converter(this.item.out.ia)
                ];
            }
        },
        methods: {
            generateItem(name) {
                const itemElement = this.item.out[name] ? this.item.out[name] : this.item[name];
                const itemElementToDisplay = this.item[name] ? this.item[name] : this.item.out[name];
                const dataElement = Diagnosis.data()[name];
                const field = this.find(dataElement, itemElement);
                return {
                    id: rowIndex++,
                    name: dataElement.name,
                    description: dataElement.description,
                    value: dataElement.converter ? dataElement.converter(itemElement) : itemElementToDisplay,
                    dimension: dataElement.dimension,
                    conclusion: field.msg,
                    _cellVariants: {value: field.style}
                }
            },
            find(field, value) {
                return _.find(field.diagnosis, function (d) {
                    return d.is(value);
                });
            },
        },
        data() {
            return {
                fields: [{
                    key: 'name',
                    label: 'Параметр',
                    class: 'text-left'
                }, {
                    key: 'value',
                    label: ' ',
                    class: 'text-center'
                }, {
                    key: 'dimension',
                    label: ' ',
                    class: 'text-left'
                }, {
                    key: 'conclusion',
                    label: 'Заключение',
                    class: 'text-left'
                }],
                radarLabels: [
                    Diagnosis.data().sop.name,
                    Diagnosis.data().ipa.name,
                    Diagnosis.data().ksd.name,
                    Diagnosis.data().iemo.name,
                    Diagnosis.data().kyad.name,
                    Diagnosis.data().ia.name
                ]
            }
        },
    }
</script>